export enum EstateAddon {
  HL_PACKAGES = "H&L Packages",
  FORMS = "Forms",
}
